import { useEffect } from "react";

import { useQuery } from "@apollo/client";
import Sentry from "@snapchat/sentry-browser";

import { type UserProfileQuery, type UserProfileQueryVariables, getUserProfile } from "../../shared/api/queries";

export const useSentryTracing = (skip = false): void => {
    const { data } = useQuery<UserProfileQuery, UserProfileQueryVariables>(getUserProfile, { skip });

    const user = data?.getUserProfile ?? null;

    useEffect(() => {
        if (user) {
            Sentry.setUser({ id: user.userId });
        } else {
            Sentry.configureScope((scope) => scope.setUser(null));
        }
    }, [user]);
};
